import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class AuthenticationLogItem {
    ID: number;
    IP: string;
    Result: boolean;
    IsNotEnabled: boolean;
    IsLocked: boolean;
    TimeconditionNotMatched: boolean;
    IpFilter: boolean;
    DateTimeCreated: Date;

    public static FixDate(item: AuthenticationLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class AuthenticationLogItemArray extends Array<AuthenticationLogItem>  {
    public LastSort = new SortItem;

    constructor(...items: AuthenticationLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AuthenticationLogItemArray.prototype);
    }


    public static FixDates(items: AuthenticationLogItemArray) {
        items.forEach(x => AuthenticationLogItem.FixDate(x));
    }

    public static SortByDate( sortThis: AuthenticationLogItemArray ): AuthenticationLogItemArray {
        sortThis.sort((a, b) => {
            if (a.ID < b.ID ) return 1;
            else if (a.ID > b.ID) return -1;
            else return 0;
        });

        return sortThis;
    }

}
